import { icArrowBigShadowDown } from '@vivareal/lina-icons'
import linkClicked from '@/utils/tracking/link-clicked'

export default {
  name: 'oz-breadcrumb-dropdown',

  props: {
    breadcrumb: {
      type: Array,
      default: [],
    },
  },

  data () {
    return {
      icons: {
        icArrowBigShadowDown,
      },
    }
  },

  methods: {
    track (event) {
      this.$clickstream.trackEvent(linkClicked('breadcrumb', event.target.innerText))
    },
  },
}
